import { render } from "./FollowUpDashboard.vue?vue&type=template&id=234db101&scoped=true"
import script from "./FollowUpDashboard.vue?vue&type=script&lang=js"
export * from "./FollowUpDashboard.vue?vue&type=script&lang=js"

import "./FollowUpDashboard.vue?vue&type=style&index=0&id=234db101&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234db101"]])

export default __exports__